import MBreadcrumbV2 from './MBreadcrumbV2.vue';
import MBreadcrumbItemV2 from './MBreadcrumbItemV2.vue';

export { MBreadcrumbV2, MBreadcrumbItemV2 };
